import { stateSetter } from '@/utils';
import { IServerColumnConfig } from '@/components/table/column-config';

// Iconițe @ant-design potrivite pentru tipuri de anunț.
export const ANNOUNCEMENT_ICON_OPTIONS: { value: string; label: string }[] = [
	{ value: 'WarningOutlined', label: 'Avertizare' },
	{ value: 'InfoCircleOutlined', label: 'Informație' },
	{ value: 'ExclamationOutlined', label: 'Exclamare' },
	{ value: 'NotificationOutlined', label: 'Notificare' },
	{ value: 'BellOutlined', label: 'Clopoțel' },
	{ value: 'FlagOutlined', label: 'Steag' },
	{ value: 'FireOutlined', label: 'Urgent' },
	{ value: 'SoundOutlined', label: 'Megafon' }
];

export interface IAnnouncementType {
	id: number | string;
	name: string;
	// String liber din BE (nume legacy „Roșu" sau HEX). Se rezolvă la HEX pentru afișare (ca la stagii).
	color?: string;
	icon?: string;
	// `default` în BE — tipul preselectat la crearea unui anunț.
	isDefault?: boolean;
	position?: number;
	description?: string | null;
	createdAt?: string;
}

// Payload create/edit — aliniat la BE (name + color + icon + default + description [+ position la PUT]).
export interface IAnnouncementTypePayload {
	name: string;
	color?: string;
	icon?: string;
	isDefault?: boolean;
	description?: string | null;
	position?: number;
}

export interface AnnouncementTypesReturnType {
	data: IAnnouncementType[];
	setData: stateSetter<IAnnouncementType[]>;
	loading: boolean;
	/** Config-ul de coloane din BE (api/announcement-types/table-config); null → coloanele locale. */
	tableConfig: IServerColumnConfig[] | null;
	loadingTableConfig: boolean;
	loadingCreate: boolean;
	loadingUpdate: boolean;
	loadingDelete: boolean;
	iconOptions: { value: string; label: string }[];
	getIconOptions: () => Promise<void>;
	getTypes: (pageParam: number, itemsParam: number) => Promise<void>;
	getTypesQuery: (queryParam: string, pageParam: number, itemsParam: number) => Promise<void>;
	createType: (payload: IAnnouncementTypePayload, onSuccess?: () => void) => Promise<void>;
	editType: (
		typeId: number | string,
		payload: IAnnouncementTypePayload,
		onSuccess?: () => void
	) => Promise<void>;
	removeType: (typeId: number | string, onSuccess?: () => void) => Promise<void>;
	page: number;
	items: number;
	setPage: stateSetter<number>;
	setItems: stateSetter<number>;
	totalPages: number;
	totalItems: number;
}
